import {useSelector, useDispatch} from 'react-redux'

const useExcelDownload = () => {
    const dispatch = useDispatch()
    const reduxData = useSelector((state) => state.modal.downloadExcel)
    const {isOpen, onChange, query, type} = reduxData
    const setOpen = (open, onChange = () => {}, type, query) => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'downloadExcel',
            data: {
                ...reduxData,
                isOpen: open,
                onChange,
                query: {...query, limit: 0},
                type,
            }
        })
    }

    const setQueryForDownloadExcel = (query) => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'downloadExcel',
            data: {
                ...reduxData,
                query,
            }
        })
    }

    return {
        isOpen,
        onChange,
        open: (onChange = () => {}, type, query) => {
            setOpen(false, onChange, type, query)
        },
        close: () => {
            setOpen(false)
        },
        toggle: () => {
            setOpen(!isOpen)
        },
        query,
        type,
        setQueryForDownloadExcel,
    }

}

export default useExcelDownload